"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetMediaDevices = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _utils = require("../../components/Join/utils");
var _StudioLogger = require("@studio/logger/StudioLogger");
var LOG = new _StudioLogger.StudioLogger('readinessChecker');

/**
 * Hook to enumerate and categorize media devices available on the user's system.
 * Attempts to access the user's media devices and categorizes them into audio input,
 * audio output, and video input devices.
 *
 * @returns {Object} An object containing arrays of available devices
 * @returns {Array} returns.audioInputDevices - Array of available audio input devices formatted for dropdown
 * @returns {Array} returns.audioOutputDevices - Array of available audio output devices formatted for dropdown
 * @returns {Array} returns.videoInputDevices - Array of available video input devices formatted for dropdown
 */
var useGetMediaDevices = exports.useGetMediaDevices = function useGetMediaDevices(_ref) {
  var _ref$audio = _ref.audio,
    audio = _ref$audio === void 0 ? false : _ref$audio,
    _ref$video = _ref.video,
    video = _ref$video === void 0 ? false : _ref$video;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    audioInputDevices = _useState2[0],
    setAudioInputDevices = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    audioOutputDevices = _useState4[0],
    setAudioOutputDevices = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    videoInputDevices = _useState6[0],
    setVideoInputDevices = _useState6[1];
  var getMediaDevices = (0, _react.useCallback)(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var devices, audioInputs, audioOutputs, videoInputs, _t, _t2;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          devices = [];
          _context.prev = 1;
          _context.next = 2;
          return navigator.mediaDevices.getUserMedia({
            audio: audio,
            // Request 1280x720 explicitly so the OS camera session is initialized at 720p.
            // When Agora's createCameraVideoTrack opens the camera afterwards, it inherits
            // this resolution instead of defaulting to 640x480.
            video: video && {
              width: {
                ideal: 1280
              },
              height: {
                ideal: 720
              },
              aspectRatio: {
                ideal: 16 / 9
              }
            }
          });
        case 2:
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          LOG.error('Error accessing media devices:' + _t);
        case 4:
          _context.prev = 4;
          _context.next = 5;
          return navigator.mediaDevices.enumerateDevices();
        case 5:
          devices = _context.sent;
          _context.next = 7;
          break;
        case 6:
          _context.prev = 6;
          _t2 = _context["catch"](4);
          LOG.error('Error enumerating media devices:', _t2);
          devices = [];
        case 7:
          audioInputs = devices.filter(function (device) {
            return device.kind === 'audioinput';
          });
          audioOutputs = devices.filter(function (device) {
            return device.kind === 'audiooutput';
          });
          videoInputs = devices.filter(function (device) {
            return device.kind === 'videoinput';
          });
          setAudioInputDevices((0, _utils.formatDevicesArrayForDropdown)(audioInputs));
          setAudioOutputDevices((0, _utils.formatDevicesArrayForDropdown)(audioOutputs));
          setVideoInputDevices((0, _utils.formatDevicesArrayForDropdown)(videoInputs));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3], [4, 6]]);
  })), [audio, video]);
  (0, _react.useEffect)(function () {
    getMediaDevices();
    var handleDeviceChange = function handleDeviceChange() {
      LOG.info('Device change detected, updating device list');
      getMediaDevices();
    };
    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);
    return function () {
      navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
    };
  }, [getMediaDevices]);
  return {
    audioInputDevices: audioInputDevices,
    audioOutputDevices: audioOutputDevices,
    videoInputDevices: videoInputDevices
  };
};